import React from 'react';
import { Link } from 'react-router-dom';

function NavigationLinksHr() {
  return (
    <div className="flex flex-wrap justify-center gap-2 md:gap-3 py-4 shadow-sm mb-6">
      <Link
        to="/hr-dashboard"
        className="px-3 py-2 bg-yellow-900 text-white rounded-lg hover:bg-yellow-600 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">HR Dashboard</span>
      </Link>
      <Link
        to="/attendance-sheet"
        className="px-3 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Attendance</span>
      </Link>
      <Link
        to="/payroll"
        className="px-3 py-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Payroll</span>
      </Link>
      <Link
        to="/payroll-monthly"
        className="px-3 py-2 bg-yellow-950 text-white rounded-lg hover:bg-yellow-800 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Monthly Payroll</span>
      </Link>
      <Link
        to="/employee-list"
        className="px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Employees</span>
      </Link>
      <Link
        to="/new-employee"
        className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Add Employee</span>
      </Link>
      <Link
        to="/payroll-settings"
        className="px-3 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Settings</span>
      </Link>
    </div>
  );
}

export default NavigationLinksHr;
